import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { gapi, errMsg, fmtDateTime } from "../api";
import { useGAuth } from "../GAuth";
import { PageHeader, Panel, Btn, Badge, inputCls } from "../components/ui";

function Sessioni() {
  const [list, setList] = useState([]);
  const load = useCallback(() => gapi.get("/auth/sessions").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const revoke = async (id) => { try { await gapi.post(`/auth/sessions/${id}/revoke`); toast.success("Sessione chiusa"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Panel title="Dispositivi collegati" testid="g-my-sessions">
      <ul className="divide-y divide-border-subtle text-sm">
        {list.map((s) => (
          <li key={s.id} className="py-3 flex justify-between gap-3 items-center">
            <span className="min-w-0"><b>{fmtDateTime(s.creataIl)}</b> · {s.ip} {s.corrente && <Badge tone="green">questo dispositivo</Badge>}<br /><span className="text-xs text-anthracite/45 break-all">{s.userAgent}</span></span>
            {!s.corrente && <Btn variant="danger" className="h-8 px-3 text-xs" onClick={() => revoke(s.id)}>Chiudi</Btn>}
          </li>
        ))}
      </ul>
    </Panel>
  );
}

function CambioPassword() {
  const [f, setF] = useState({ attuale: "", nuova: "", nuova2: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.nuova !== f.nuova2) return toast.error("Le password non coincidono");
    try { await gapi.post("/auth/password/change", { attuale: f.attuale, nuova: f.nuova }); toast.success("Password aggiornata. Le altre sessioni sono state chiuse."); setF({ attuale: "", nuova: "", nuova2: "" }); }
    catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <Panel title="Cambia password">
      <form onSubmit={submit} className="space-y-3">
        <input type="password" className={inputCls} placeholder="Password attuale" value={f.attuale} onChange={(e) => setF({ ...f, attuale: e.target.value })} required data-testid="g-pwd-current" />
        <input type="password" className={inputCls} placeholder="Nuova password (min. 10, lettere e numeri)" value={f.nuova} onChange={(e) => setF({ ...f, nuova: e.target.value })} required data-testid="g-pwd-new" />
        <input type="password" className={inputCls} placeholder="Ripeti nuova password" value={f.nuova2} onChange={(e) => setF({ ...f, nuova2: e.target.value })} required data-testid="g-pwd-new2" />
        <Btn type="submit" data-testid="g-pwd-save">Aggiorna password</Btn>
      </form>
    </Panel>
  );
}

function CodiciRecupero() {
  const { refresh, session } = useGAuth();
  const [pw, setPw] = useState("");
  const [codes, setCodes] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await gapi.post("/auth/recovery-codes", { password: pw }); setCodes(data.codiciRecupero); setPw(""); refresh(); }
    catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <Panel title="Codici di recupero (verifica in due passaggi)">
      <p className="text-sm text-anthracite/60 mb-3">Rimasti: <b>{session.codiciRecuperoRimasti}</b>. Generandone di nuovi, quelli precedenti smettono di funzionare.</p>
      {codes ? (
        <div className="grid grid-cols-2 gap-2 font-mono text-sm" data-testid="g-new-recovery-codes">{codes.map((c) => <div key={c} className="rounded-lg border border-border-subtle px-3 py-2 text-center">{c}</div>)}</div>
      ) : (
        <form onSubmit={submit} className="flex gap-2">
          <input type="password" className={inputCls} placeholder="Conferma con la password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="g-recovery-password" />
          <Btn type="submit" data-testid="g-recovery-generate">Genera</Btn>
        </form>
      )}
    </Panel>
  );
}

export default function Profilo() {
  const { session } = useGAuth();
  const u = session.user;
  return (
    <div data-testid="g-profile-page">
      <PageHeader eyebrow="Il mio account" title={u.nome} desc={`${session.ruoli[u.ruolo]} · ${u.email}`} />
      <div className="grid lg:grid-cols-2 gap-5">
        <CambioPassword />
        {u.ruolo === "titolare" && <CodiciRecupero />}
        <div className="lg:col-span-2"><Sessioni /></div>
      </div>
    </div>
  );
}
